/* =====================================================================
   R21 — THE YEAR INDEX, LIVE

   Tommy, on the merged engine: "'the survey 2022 to date' — doesn't work
   right? doesn't change says 'date', etc.?"

   It did not work at all. THE INDEX WAS A PICTURE OF AN INDEX. v32 drew
   it as live SVG over the sheet and the engine rasters that whole SVG once
   into the furniture texture, so the bracket was frozen where the dump
   happened to leave it (over 2026, the home fit's own extent) and the red
   figure was frozen on 2026 with it. Pan three years west and the index
   still said you were at the east end of the record. R14 made ONE cell of
   it live — 2026's, as a second way home — and wrote the rest down as
   open. This is the rest.

   WHAT THE INDEX IS, in v32's own words (survey-map.js :5732): "There are
   no adjoining sheets to index, because there is one continuous strip of
   ground and the window slides along it. So the index is not a row of
   sheet cells any more: it is the whole survey drawn as a RULE, lettered
   with its years, with the window's own extent shown over it as a BRACKET
   — which is what an Ordnance sheet's diagram of adjoining sheets was
   always for (where am I, and what is next to me) and what a scrollbar is
   for on a screen. The bracket is dragged to travel; a year is clicked to
   go to it; the year you are already on lays the sheet back out at home."

   So there are three live things and they are all driven from the camera:

     THE BRACKET   is the window's extent, mapped through the rule. It is
                   read from `Room.view` every frame — the two ends of the
                   view turned into week numbers and the week numbers into
                   positions along the rule — and it is DRAGGED to travel:
                   a hand's width along the rule is a hand's width of the
                   survey (markYearIndex :5840, wireIndexDrag :5812).
     THE FIGURES   go red when their year holds at least 15 % of the
                   window, so the home fit marks one year and a window
                   across a New Year marks two.
     THE CELL      is clicked to travel to its year at the fit's zoom —
                   unless it is a marked one, which lays the sheet back
                   out flat instead (Room.home).

   R79: THE MARK IS INK AGAIN. A DOM plate can only be one plane, and since
   R65/R67 the paper under this rule is not: it rises over the field book and
   falls back to the oak. At the 2023 window the long bracket missed the
   paper by 2.21 css px at its west end and 2.78 at its east. The five year
   figures are narrow and never cross a support bend, so their original
   printed forms stay in the furniture texture; objects.js recolours the
   marked one there and draws the bracket analytically in the sheet pass.
   Both therefore take paperH and the book support with the sheet. This SVG
   is now the invisible hit map only.

   ONE HIT MAP, NOT SEVEN. The whole index remains one <svg> in the over
   layer's units. Per frame this module writes at most one matrix string,
   one invisible path, two grip attributes and a class toggle; the sheet
   pass asks `ink()` for the same current bounds before it draws.
   ===================================================================== */
(function () {
'use strict';

/* ?idx=0 PINS THE PRINTED INDEX, for the pair — R14's ?pin=0 and R13's
   ?fine=0 are the same device. With this module out of the page the
   furniture keeps v32's rastered bracket and its frozen red 2026, because
   furniture() only strips them when RoomIndex exists: the two loads differ
   by this item and by nothing else. */
if (/[?&]idx=0\b/.test(location.search)) return;

/* ---- WHERE THE PRINTED ONE IS -------------------------------------
   Every number here is read straight off the raster (src/img/
   sheet-frame.svg, the `sv-index` group), and they are in the OVER
   LAYER's units, not the sheet's: v32 built the rose, the cartouche, the
   index and the pin into `sv-over`, which the dump carries as one group
   with transform="scale(1.297476) translate(-49,-51.890625)". A sheet
   unit is 1.297476 of them. The same three numbers R14 measured. */
var OVER = { k: 1.297476, dx: -49, dy: -51.890625 };
function sheetX(x) { return (x + OVER.dx) * OVER.k; }
function sheetY(y) { return (y + OVER.dy) * OVER.k; }

/* footPlan's own figures, as the raster froze them: the rule runs from
   `X` for `W`, the cells stand on `Y0` and are `H + 6` deep, and the rule
   itself is at Y0 + H * 0.62 (buildYearIndex :5754). */
var X = 109.88747884940778, W = 340, Y0 = 839.6252115059222, H = 20;
var RULE_Y = Y0 + H * 0.62;
/* the element's own box, in those same units: wide enough for the grip at
   either end of the rule (x0 - 3 .. x1 + 3) and deep enough for the
   bracket's top (RULE_Y - 7) and the figures' descenders */
var BOX = { x: 104, y: 830, w: 352, h: 44 };

var DAY = 86400000, SVG = 'http://www.w3.org/2000/svg';
var S = null, root = null, line = null, grip = null;
var cells = [], I = null;
var mat = '', dBr = '', gx = '', gw = '', hereKey = '', laid = 0, wasFit = null;
var inkVX = NaN, inkVW = NaN;
var inkMark = { x0: 0, x1: 0, first: 0, last: 0, off: '', offYears: 0,
                bracket: [0, 0, 0, 0], years: [0, 0, 0, 0] };

/* ---- THE RECORD'S OWN ARITHMETIC (survey-map.js :1316, :1370) ------
   t is a WEEK INDEX from the epoch — the Sunday on or before the 1st of
   January of the home year — which is exactly what the field is built on
   (field.js :149), so the same integer means the same column of ground in
   both. The index is drawn in weeks and the sheet is laid out in weeks;
   there is no third unit anywhere in this file. */
function weekOf(iso, epoch) { return Math.floor((Date.parse(iso + 'T00:00:00Z') - epoch) / (7 * DAY)); }

function epochOf(home) {
  var C = window.RoomField.C, d = new Date(Date.UTC(home, 0, 1));
  d.setUTCDate(d.getUTCDate() - (C.WEEK_START === 'sunday' ? d.getUTCDay() : (d.getUTCDay() + 6) % 7));
  d.setUTCHours(0, 0, 0, 0);
  return d.getTime();
}

function yearPlan(home, epoch) {
  var C = window.RoomField.C;
  home = Math.max(C.EARLIEST_YEAR, +home || C.EARLIEST_YEAR);
  epoch = epoch === undefined ? epochOf(home) : epoch;
  var years = [], y;
  for (y = C.EARLIEST_YEAR; y <= home; y++) years.push(y);
  var span = years.map(function (yy) {
    return { year: yy, from: weekOf(yy + '-01-01', epoch),
             to: (yy >= home ? weekOf(yy + '-12-31', epoch)
                             : weekOf((yy + 1) + '-01-01', epoch) - 1) };
  });
  var tW = span[0].from, tE = span[span.length - 1].to + 1;
  return {
    homeYear: home, years: years, span: span, tW: tW, tE: tE,
    xAt: function (t) { return X + Math.max(0, Math.min(1, (t - tW) / (tE - tW))) * W; },
    /* the sheet's own two mappings, t <-> map x (field.js alongOf) */
    tAt: function (x) { return (x - C.px) / C.cw; },
    alongOf: function (t) { return C.px + t * C.cw; },
    across: C.py + 3.5 * C.ch      /* the middle row: every hash's y */
  };
}

function plan() {
  var F = S.fld;
  return yearPlan(F.homeYear, F.days.epochMs);
}

/* ---- THE FURNITURE LOSES WHAT CANNOT BE PRINTED -------------------
   TURNED OFF, NOT CUT OUT, and that is a measurement and not a taste.
   Deleting the bracket's group and the five <text> elements from the
   string moved 280 pixels of the CARTOUCHE — its panel's own strokes and
   its red dot, three hundred units away and painted before any of them —
   by a delta of 1 to 3. Two loads of the same string are identical to the
   pixel (measured: 0 differing pixels between two separate loads), so it
   is the EDIT that does it: the rasteriser's output for a path is not
   independent of what else is in the document. Setting opacity to zero
   leaves every element, its geometry and its order exactly where they
   were, and the fit comes out at 0 differing pixels outside the index. */
function printIndex(P) {
  var out = '', last = P.span.length - 1;
  P.span.forEach(function (sp, i) {
    var a = P.xAt(sp.from), c = P.xAt(sp.to + 1);
    out += '<g class="sv-index-cell' + (i === last ? ' is-here' : '') + '" data-year="' + sp.year + '">' +
      '<path d="M' + a.toFixed(1) + ' ' + (RULE_Y - 4) + 'v8" class="sv-index-tick"></path>' +
      '<text x="' + ((a + c) / 2) + '" y="' + (RULE_Y + 15) + '" class="sv-index-year" text-anchor="middle">' + sp.year + '</text>' +
      '<rect x="' + a + '" y="' + Y0 + '" width="' + (c - a) + '" height="' + (H + 6) + '" class="sv-index-box"></rect></g>';
  });
  out += '<path d="M' + P.xAt(P.tE).toFixed(1) + ' ' + (RULE_Y - 4) + 'v8" class="sv-index-tick"></path>';
  /* This group is retained for source/raster stability, but R79 makes it
     invisible below; the live bracket is drawn by the sheet fragment. */
  out += '<g class="sv-index-bracket" id="sv-index-bracket"><path d="M0 0" class="sv-index-bracket-line" id="sv-index-bracket-line"></path>' +
    '<rect x="0" y="' + Y0 + '" width="0" height="' + (H + 6) + '" class="sv-index-grip" id="sv-index-grip"></rect></g>';
  return out;
}

function groupEnd(s, at) {
  var re = /<g\b[^>]*>|<\/g>/g, m, depth = 0;
  re.lastIndex = at;
  while ((m = re.exec(s))) {
    if (m[0].slice(0, 3) === '</g') depth--;
    else depth++;
    if (depth === 0) return re.lastIndex;
  }
  return -1;
}

function prepFurniture(s, homeYear) {
  /* The bitmap starts before the worker's field is available, but boot has
     already read this one integer from the filed record. If that year no
     longer matches the serialised SVG, strike every cell from the exact
     same week plan build() uses. Current 2026 takes no such edit, retaining
     the accepted raster byte-for-byte outside bracket opacity. */
  var a = s.indexOf('<g class="sv-index">'), b = groupEnd(s, a);
  if (a >= 0 && b > a && homeYear) {
    var g = s.slice(a, b), got = [], re = /data-year="(\d{4})"/g, m;
    while ((m = re.exec(g))) got.push(+m[1]);
    var P = yearPlan(homeYear), same = got.length === P.years.length;
    for (var i = 0; same && i < got.length; i++) same = got[i] === P.years[i];
    if (!same) {
      var cellsAt = g.indexOf('<g class="sv-index-cell"');
      if (cellsAt >= 0) {
        g = g.slice(0, cellsAt) + printIndex(P) + '</g>';
        s = s.slice(0, a) + g + s.slice(b);
      }
    }
  }
  /* the bracket, whose whole job is to say where the window is */
  s = s.replace(/<g class="sv-index-bracket"/, '<g opacity="0" class="sv-index-bracket"');
  /* R79: the figures are paper ink again. The sheet shader recolours the
     marked figure; retaining all five in this one raster keeps one typeface,
     one weight and one physical surface. */
  return s;
}

/* ---- THE ELEMENT ---------------------------------------------------
   Built here rather than written into base.njk because the years come
   from the record: there are five today and there will be six in January.
   base.njk holds the empty <svg>, so the box is laid out from the first
   paint and the class landing costs a paint and not a relayout. */
function el(n, a) {
  var e = document.createElementNS(SVG, n);
  for (var k in a) e.setAttribute(k, a[k]);
  return e;
}
function build() {
  root.setAttribute('viewBox', BOX.x + ' ' + BOX.y + ' ' + BOX.w + ' ' + BOX.h);
  root.setAttribute('width', BOX.w); root.setAttribute('height', BOX.h);
  I.span.forEach(function (sp, i) {
    var a = I.xAt(sp.from), c = I.xAt(sp.to + 1);
    var g = el('g', { class: 'sx-cell', 'data-year': sp.year });
    var t = el('text', { x: ((a + c) / 2).toFixed(3), y: (RULE_Y + 15).toFixed(3),
                         class: 'sx-year', 'text-anchor': 'middle', visibility: 'hidden' });
    t.textContent = String(sp.year);
    g.appendChild(t);
    /* the target is the whole stretch of rule that year owns (:5783) */
    g.appendChild(el('rect', { x: a.toFixed(3), y: Y0, width: Math.max(4, c - a).toFixed(3),
                               height: H + 6, class: 'sx-box' }));
    cells.push({ g: g, year: sp.year, i: i });
    root.appendChild(g);
    wireCell(g, sp.year, i);
  });
  /* THE BRACKET, over the rule: a square bracket with its ends turned
     down on to it, the way an extent is marked on a scale — and the
     handle the reader travels by. */
  var br = el('g', { class: 'sx-bracket' });
  line = el('path', { class: 'sx-bracket-line', d: 'M0 0', visibility: 'hidden' });
  grip = el('rect', { class: 'sx-grip', x: 0, y: Y0, width: 10, height: H + 6 });
  br.appendChild(line); br.appendChild(grip);
  root.appendChild(br);
  wireDrag();
}

/* ---- DRIVEN FROM THE CAMERA, EVERY FRAME (markYearIndex :5840) -----
   Five cells and two attributes: the whole of it is a dozen divisions and
   a string compare, inside draw(), and it writes to the DOM only when a
   value it would write has changed. */
function ink(st) {
  if (st && st.view) S = st;
  if (!I) { ensure(); if (!I) return null; }
  var v = S.view;
  if (v.x === inkVX && v.w === inkVW) return inkMark;
  inkVX = v.x; inkVW = v.w;
  var t0 = I.tAt(v.x), t1 = I.tAt(v.x + v.w);
  var lo = Math.min(t0, t1), hi = Math.max(t0, t1);
  var x0 = I.xAt(lo), x1 = I.xAt(hi);
  if (x1 - x0 < 7) { var mid = (x0 + x1) / 2; x0 = mid - 3.5; x1 = mid + 3.5; }
  var span = hi - lo || 1, first = -1, last = -1;
  I.span.forEach(function (sp, i) {
    var over = Math.min(hi, sp.to + 1) - Math.max(lo, sp.from);
    if (over / span >= 0.15) { if (first < 0) first = i; last = i; }
  });
  if (first < 0) {
    var c = (lo + hi) / 2, best = 0, bd = Infinity;
    I.span.forEach(function (sp, i) {
      var dd = Math.abs((sp.from + sp.to + 1) / 2 - c);
      if (dd < bd) { bd = dd; best = i; }
    });
    first = last = best;
  }
  var fa = I.span[first], la = I.span[last];
  inkMark.x0 = x0; inkMark.x1 = x1; inkMark.first = first; inkMark.last = last;
  /* ==== CA1 (2026-09-24): OFF THE RECORD, AN ARROW AND NOT A BLIP.
     Tommy: the index "shows a red box of the current map selection when
     we're pre-2022 or into terra incognita. it's currently just a little
     red blip at the left or right". With the whole view off the rule the
     bracket had nowhere to be and was pinned to the end seven units wide.
     Now it is not drawn at all (x1 = x0, which the sheet pass reads as no
     bracket), and `lay` prints a chart's continued-arrow at that end of
     the rule with the years the view is off it (`offArrow`). ==== */
  inkMark.off = hi < I.tW ? 'W' : (lo > I.tE ? 'E' : '');
  inkMark.offYears = inkMark.off === 'W' ? Math.round((I.tW - (lo + hi) / 2) / 52.1775)
                   : inkMark.off === 'E' ? Math.round(((lo + hi) / 2 - I.tE) / 52.1775) : 0;
  inkMark.bracket[0] = sheetX(x0); inkMark.bracket[1] = inkMark.off ? sheetX(x0) : sheetX(x1);
  inkMark.bracket[2] = sheetY(RULE_Y); inkMark.bracket[3] = sheetY(RULE_Y - 7);
  /* Marked years are contiguous by construction. One interval therefore
     covers New Year pairs and any deliberately wide supported view without
     leaving an intervening figure black. */
  inkMark.years[0] = sheetX(I.xAt(fa.from)); inkMark.years[1] = sheetX(I.xAt(la.to + 1));
  /* z/w delimit every printed figure too. Unlike a literal 2022--26
     rectangle this grows with the record when January adds another cell. */
  inkMark.years[2] = sheetX(I.xAt(I.span[0].from));
  inkMark.years[3] = sheetX(I.xAt(I.span[I.span.length - 1].to + 1));
  return inkMark;
}

function lay(st) {
  S = st;
  if (!root) return;
  var mark = ink(st);
  if (!mark) return;
  /* R30: THE WHOLE INDEX IS ONE SVG AND THE SVG IS A BOX, so it is laid
     by the projective transform and not by the affine. At the desk's edge
     pose the affine put the rule's EAST end 2.80 device px west of where
     the camera puts it at 1.75 (1.99 at 1.25) — the bracket is driven in
     the same units, so the bracket walked with it and the 2026 cell was
     the one furthest out. `Room.onPaperQuad` hands the 2D matrix straight
     back at the flat pose, where the residual is nothing. */
  var m = Room.onPaperQuad(sheetX(BOX.x), sheetY(BOX.y), OVER.k, BOX.w, BOX.h);
  if (m === null) {
    if (root.style.visibility !== 'hidden') root.style.visibility = 'hidden';
    return;
  }
  if (root.style.visibility) root.style.visibility = '';
  if (m !== mat) { mat = m; root.style.transform = m; }
  /* nothing is shown until it has been laid on the paper: an element with
     no matrix sits at the window's own origin, which is the bare desk */
  if (!laid) { laid = 1; root.classList.add('is-laid'); }

  offArrow(mark);                          /* CA1 */
  var x0 = mark.x0, x1 = mark.x1;
  var d = 'M' + x0.toFixed(1) + ' ' + RULE_Y.toFixed(3) + 'V' + (RULE_Y - 7).toFixed(3) +
          'H' + x1.toFixed(1) + 'V' + RULE_Y.toFixed(3);
  if (d !== dBr) { dBr = d; line.setAttribute('d', d); }
  var a = (x0 - 3).toFixed(1), b = Math.max(9, x1 - x0 + 6).toFixed(1);
  if (a !== gx) { gx = a; grip.setAttribute('x', a); }
  if (b !== gw) { gw = b; grip.setAttribute('width', b); }

  /* WHICH YEAR YOU ARE IN. A year is marked when it holds a real share of
     the window — v32's 0.15 — so the home fit marks one year and a window
     straddling a New Year marks two. If the window is wholly off the
     record (the beyond runs a long way west and east) the nearest year to
     its middle is marked, so the index always says something. */
  var first = mark.first, last = mark.last;
  var key = first + ':' + last;
  if (key !== hereKey) {
    hereKey = key;
    for (var i = 0; i < cells.length; i++)
      cells[i].g.classList.toggle('is-here', i >= first && i <= last);
  }
  /* AND AT THE FIT THE MARKED CELL HAS NOTHING TO DO, so it says nothing:
     no cursor, no answer — R14's rule for the pin, kept. Asked and written
     only when the answer changes, so a pan costs nothing here. */
  var fit = !!(window.Room && Room.atFit && Room.atFit());
  if (fit !== wasFit) { wasFit = fit; root.classList.toggle('is-fitted', fit); }
}

/* ---- A YEAR IS CLICKED TO GO TO IT ---------------------------------
   And the year you are already on lays the sheet back out at home — which
   is the behaviour R14 gave the 2026 cell, kept and generalised: at the
   fit the marked cell has nothing to do, so it is inert (no cursor, no
   answer), exactly as the pin is. */
function travel(year, i) {
  var sp = I.span[i];
  if (cells[i].g.classList.contains('is-here')) {
    if (Room.atFit && Room.atFit()) return;      /* already there */
    Room.home(true);
    return;
  }
  Room.easeTo(I.alongOf((sp.from + sp.to + 1) / 2), I.across, Room.fitWidth());
}
/* ==== B4: EVERY OTHER WAY A HAND CAN LEAVE A GRIP IN THIS FILE ========
   B3's finding, applied to the index's six grips (five year cells and the
   bracket). Each of them asks for the pointer to be CAPTURED inside a
   try/catch, because the capture can simply not be given, and it can be
   taken away again afterwards: another element takes the pointer, the
   button is let go outside the window, the window loses focus mid-drag,
   the tab is hidden. In each of those the up lands somewhere else or never
   happens at all, and until now nothing else cleared what the press set.

   MEASURED before this card (room-rev10/b4-specs/before-175.json), on all
   four paths. The BRACKET keeps `from` and its `is-held` class, and `from`
   is the only gate `pointermove` reads — it never looks at `e.buttons` —
   so a pointer merely PASSING OVER the rule with no button held went on
   travelling the survey: the view ran -1411 -> -3711 on one button-less
   move, three and a half years under a hand that is not touching it. A
   YEAR CELL keeps `down` with `moved` at 0, so the next release to land on
   that cell is read as a push nobody made: a bare up over 2022 threw the
   view 122 -> -8238.

   `hangLoss` hangs a grip's RELEASE HALF — what the up does MINUS the
   travel, exactly as this file's cancel has always had it, because a lost
   pointer is not a tap — on `lostpointercapture` and `pointercancel` at
   the grip, and on the four window-level losses. The window pair is wired
   ONCE for the whole file rather than once per grip (six grips would
   otherwise hang twenty-four listeners on an event that fires on every
   release anywhere on the page), and it sits in the BUBBLE phase, below
   each grip's own up, so a release that does reach its grip is answered
   there first — with its travel and its stopPropagation — and this finds
   nothing left. The pointer id is carried so that one finger letting go
   never ends another finger's drag. Nothing here runs per frame. ==== */
var losers = [], lossWired = 0;
function letGoAll(id) { for (var i = 0; i < losers.length; i++) losers[i](id); }
function hangLoss(el, release) {
  losers.push(release);
  el.addEventListener('lostpointercapture', function (e) { release(e.pointerId); });
  el.addEventListener('pointercancel', function (e) { release(e.pointerId); });
  if (lossWired) return;
  lossWired = 1;
  window.addEventListener('pointerup', function (e) { letGoAll(e.pointerId); });
  window.addEventListener('pointercancel', function (e) { letGoAll(e.pointerId); });
  /* the hand is now in another window or on another tab, and no pointer
     event of any kind is coming back for any of them */
  window.addEventListener('blur', function () { letGoAll(); });
  document.addEventListener('visibilitychange', function () { if (document.hidden) letGoAll(); });
}

function wireCell(g, year, i) {
  var down = null, moved = 0, pid = -1;
  function inert() {
    /* X2: and the index is a thing PRINTED ON THE MAP, so it is as
       detached as the map is — standing in the room, or with the sheet
       folded, a cell is a cell of print and not a control. */
    if (Room.mapLive && !Room.mapLive()) return true;
    return g.classList.contains('is-here') && Room.atFit && Room.atFit();
  }
  g.addEventListener('pointerdown', function (e) {
    if (inert()) return;
    e.stopPropagation(); e.preventDefault();
    down = { x: e.clientX, y: e.clientY }; moved = 0; pid = e.pointerId;
    try { g.setPointerCapture(e.pointerId); } catch (err) { /* fine */ }
  });
  g.addEventListener('pointermove', function (e) {
    if (!down) return;
    moved += Math.abs(e.clientX - down.x) + Math.abs(e.clientY - down.y);
    down = { x: e.clientX, y: e.clientY };
  });
  g.addEventListener('pointerup', function (e) {
    if (!down) return;
    down = null; e.stopPropagation();
    if (moved <= 4 && !inert()) travel(year, i);
  });
  /* B4: the release half of the up above — the hand let go of the cell,
     and a hand that was taken away did not travel to its year. */
  hangLoss(g, function (id) {
    if (id !== undefined && id !== pid) return;
    if (!down) return;
    down = null; moved = 0;
  });
  g.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); });
  g.addEventListener('dblclick', function (e) { e.stopPropagation(); });
}

/* ---- AND THE BRACKET IS DRAGGED TO TRAVEL (wireIndexDrag :5812) -----
   "The rule is the whole record, so a hand's width along it is a hand's
   width of the survey."

   v32 took the hand's movement as a number of screen pixels along x,
   because its index was flat DOM over a flat sheet. Ours is laid ON THE
   PAPER by a matrix, so the rule runs whichever way the sheet is turned
   and can be foreshortened to a fraction of its length by a tilt. The
   hand's movement is therefore PROJECTED ON TO THE RULE's own direction,
   which is the matrix's first column (a, b) — one unit along the rule
   moves the pointer by exactly that vector — so the drag tracks the paper
   at any attitude and reduces, on a flat north-up sheet, to v32's dx. */
function wireDrag() {
  var from = null, pid = -1;
  grip.addEventListener('pointerdown', function (e) {
    if (!I) return;
    if (Room.mapLive && !Room.mapLive()) return;   /* X2 */
    e.stopPropagation(); e.preventDefault();
    if (Room.stopMove) Room.stopMove();
    try { grip.setPointerCapture(e.pointerId); } catch (err) { /* fine */ }
    /* the rule's direction on the screen, css px per unit of the rule:
       its two ends put through the engine's own projection. (It used to
       be read out of `mat` as `matrix(a,b,…)`; since R30 (a) the index is
       laid by `matrix3d(…)`, so that read NaN and the first move sent the
       view to NaN,NaN — the map blank, the hash `#NaN,NaN,…`.) */
    var p0 = Room.paperPoint(sheetX(X), sheetY(RULE_Y)),
        p1 = Room.paperPoint(sheetX(X + W), sheetY(RULE_Y));
    if (!p0 || !p1) return;
    from = { x: e.clientX, y: e.clientY, a: (p1[0] - p0[0]) / W, b: (p1[1] - p0[1]) / W, moved: 0,
             cx: S.view.x + S.view.w / 2, cy: S.view.y + S.view.h / 2 };
    pid = e.pointerId;
    grip.classList.add('is-held');
  });
  grip.addEventListener('pointermove', function (e) {
    if (!from) return;
    var a = from.a, b = from.b, q = a * a + b * b;
    if (q < 1e-9) return;                      /* the sheet is edge-on */
    from.moved = Math.max(from.moved,
      Math.abs(e.clientX - from.x) + Math.abs(e.clientY - from.y));
    var du = ((e.clientX - from.x) * a + (e.clientY - from.y) * b) / q;
    var weeks = du / W * (I.tE - I.tW);
    Room.centreOn(from.cx + weeks * window.RoomField.C.cw, from.cy);
  });
  /* AND A TAP ON THE BRACKET IS A TAP ON THE YEAR UNDER IT, which is not
     a nicety: the bracket sits ON the window's own extent and the marked
     year is by definition the one holding that window, so the grip covers
     most of the cell that lays the sheet back out flat. v32 had the same
     two rectangles in the same order and the same overlap (buildYearIndex
     appends the bracket after the cells) and its "the year you are already
     on lays the sheet back out at home" was unreachable wherever the two
     met — measured here on the real pointer: elementFromPoint at the
     middle of a marked 2023 returns `sx-grip`, and the click did nothing.
     A hand that moved is a drag; a hand that did not is a push, and it
     goes to whatever is under it. */
  function tapThrough(e) {
    grip.style.pointerEvents = 'none';
    var el = document.elementFromPoint(e.clientX, e.clientY);
    grip.style.pointerEvents = '';
    if (!el || !el.parentNode) return;
    for (var i = 0; i < cells.length; i++)
      if (cells[i].g === el.parentNode) { travel(cells[i].year, i); return; }
  }
  function up(e) {
    if (!from) return;
    var tap = from.moved <= 4;
    from = null; grip.classList.remove('is-held');
    try { grip.releasePointerCapture(e.pointerId); } catch (err) { /* fine */ }
    if (tap) tapThrough(e);
  }
  grip.addEventListener('pointerup', up);
  /* a cancelled pointer is not a push: the hand left, it did not arrive.
     B4: and neither is a pointer that was taken away in any of the other
     three ways — same release, same reason, hung on all of them. */
  hangLoss(grip, function (id) {
    if (id !== undefined && id !== pid) return;
    if (!from) return;
    from = null; grip.classList.remove('is-held');
  });
  grip.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); });
  grip.addEventListener('dblclick', function (e) { e.stopPropagation(); });
}

/* ---- AND NOT UNTIL THE RECORD IS HERE ------------------------------
   The index is lettered FROM the record — five years today, six in
   January — so on a cold load, where the engine draws its first frame
   against the stub field while the worker is still building the real one
   (engine.js :2054), there is nothing to letter yet. init() is called in
   that frame, with the pin and the books; the rule is printed and already
   on the paper by then, so the only thing waiting is the DOM over it, and
   it lands with the window opening. On a warm cache the field is there at
   init and this happens in the same frame. */
/* ==== CA1: THE CONTINUED-ARROW, PRINTED INTO THE SHEET. The index's
   figures are print in the furniture texture, so the arrow is too: struck
   with `Room.furnPatch` (the section's and the range's way) over the
   index's own box, only when what it says changes — which end, and how
   many years — and struck back to the bare print when the view comes onto
   the record. A chart's arrow off the end of the rule, in the bracket's
   red, above the rule where the bracket stands, and the years off it
   beside its tail in the figures' own face. No click (Tommy: "We don't
   need to bother with clicking the arrow taking you back"). ==== */
var arrowKey = '', ARROW_RED = '#96322a';
function offArrow(mark) {
  var key = mark.off ? mark.off + ':' + mark.offYears : '';
  if (key === arrowKey || !window.Room || !Room.furnPatch) return;
  var bx = sheetX(BOX.x), by = sheetY(BOX.y), bw = BOX.w * OVER.k, bh = BOX.h * OVER.k;
  var off = mark.off, yrs = mark.offYears;
  var ok = Room.furnPatch(bx, by, bw, bh, function (ctx, R) {
    if (!off) return;                          /* the bare print back */
    var u = OVER.k, y = sheetY(RULE_Y - 4);
    var tip = sheetX(off === 'W' ? X : X + W), dir = off === 'W' ? 1 : -1;
    ctx.setTransform(R.k, 0, 0, R.k, -R.px, -R.py);
    ctx.strokeStyle = ARROW_RED; ctx.fillStyle = ARROW_RED;
    ctx.lineWidth = 1.1 * u; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    ctx.beginPath();
    ctx.moveTo(tip + dir * 16 * u, y); ctx.lineTo(tip, y);
    ctx.moveTo(tip + dir * 5 * u, y - 3.2 * u); ctx.lineTo(tip, y); ctx.lineTo(tip + dir * 5 * u, y + 3.2 * u);
    ctx.stroke();
    if (yrs >= 1) {
      ctx.font = (8.5 * u).toFixed(2) + 'px "Sorts Mill Goudy Print", "Sorts Mill Goudy", Georgia, serif';
      ctx.textBaseline = 'middle'; ctx.textAlign = off === 'W' ? 'left' : 'right';
      ctx.fillText(String(yrs), tip + dir * 19 * u, y + 0.4 * u);
    }
  });
  if (ok) arrowKey = key;
}

function ensure() {
  if (I || !root || !S || !S.fld || S.fld.stub || !window.RoomField) return;
  I = plan();
  build();
}

function init(st) {
  S = st;
  root = document.getElementById('sheet-index');
  ensure();
}

window.RoomIndex = { init: init, lay: lay, ink: ink, prepFurniture: prepFurniture };
})();
